/**
 * The argument names a tool call uses for the one file it acts on.
 *
 * Every surface that has to answer "which file is this row about?" — the row's
 * label and preview chip, the MCP write recognizer — asks here, so a spelling
 * learned in one place is known in all of them. The agents disagree on the
 * spelling and none of them is canonical: the Claude tools take `file_path`
 * and `notebook_path`, while an ACP agent (OpenCode) reports `filePath`. Each
 * entry is a spelling an agent actually sends; a guessed one would read as
 * coverage this module does not have.
 */

/** Path argument names, most specific first. */
export const PATH_ARGUMENTS = ['file_path', 'filePath', 'notebook_path', 'path'] as const;

/**
 * The path a call names, or undefined when it names none of these.
 *
 * An empty string is not a path: it names no file, and a row that took it as
 * one would render with no subject at all rather than falling through to
 * whatever else could name it.
 */
export function pathArgument(input: Record<string, unknown>): string | undefined {
  for (const key of PATH_ARGUMENTS) {
    const value = input[key];
    if (typeof value === 'string' && value) return value;
  }
  return undefined;
}
